<ng-container *ngIf="showNotifications">
    <sm-toasts [toasts]="notifications" (onClickLink)="onClickLink($event)"></sm-toasts>
</ng-container>